import React, { useMemo } from 'react';
import { bool } from 'prop-types';
import { NamedLink, Tooltip } from '../../components';

import css from './CalendarEvent.module.css';
import classNames from 'classnames';
import { useIntl } from 'react-intl';

const CalendarEvent = props => {
  const { title, showTitle, event } = props;

  const intl = useIntl();

  const { resource } = useMemo(() => event || {}, [event]);

  const { id: txId, booking } = useMemo(() => resource || {}, [resource]);

  const { attributes } = booking || {};

  const { protectedData } = attributes || {};

  const { eventType } = protectedData || {};

  return (
    <NamedLink
      name="SaleDetailsPage"
      params={{ id: txId }}
      className={classNames('rbc-event-content', css.root)}
    >
      <span className={css.customerName}>
        {`${event.start.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}, 
        ${intl.formatMessage({ id: `General.${eventType}` })}`}
      </span>

      {/* <span className={css.eventType}>x{seats}</span> */}
    </NamedLink>
  );
};

CalendarEvent.propTypes = {
  showTitle: bool,
};

export default CalendarEvent;
